<template>
  <v-menu v-model="open" class="filter-menu" offset-y top :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        class="custom-button"
        :style="{ color: getAssets.colors.home.input, border: `1px solid ${getAssets.colors.home.input}`, backgroundColor: 'transparent' }"
        v-on="on"
      >
        <v-icon :color="getAssets.colors.home.input" class="mr-3">qr_code</v-icon>
        Fazer download do app</v-btn
      >
    </template>
    <v-card class="pa-2 pb-4 card-content" width="420px">
      <div class="d-flex justify-end">
        <v-icon class="cursor-pointer" size="24" color="#31363b" @click="open = false">close</v-icon>
      </div>

      <div class="stores-items d-flex align-center justify-center">
        <qr-code-button
          v-if="['android', 'desktop'].includes(operatingSystem) && stores.play_store_link"
          :link="stores.play_store_link"
          class="mr-1"
          variant="playstore"
        />
        <qr-code-button
          v-if="['ios', 'desktop'].includes(operatingSystem) && stores.app_store_link"
          :link="stores.app_store_link"
          class="ml-1"
          variant="apple"
        />
      </div>

      <p>Escaneie o QR code com o celular para baixar o app.</p>
    </v-card>
  </v-menu>
</template>

<script>
import QrCodeButton from '@/modules/users/views/components/QrCodeButton.vue'
export default {
  name: 'QrCodesMenu',
  components: { QrCodeButton },
  props: {
    stores: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    open: false
  }),
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    operatingSystem() {
      const userAgent = navigator.userAgent.toLowerCase()

      if (/android/.test(userAgent)) return 'android'
      else if (/iphone|ipad|ipod/.test(userAgent)) return 'ios'
      else return 'desktop'
    }
  }
}
</script>

<style lang="scss" scoped>
.card-content {
  border-radius: 16px;
  .cursor-pointer {
    cursor: pointer !important;
  }
  p {
    color: #78838e;
    font-weight: 400;
    font-size: 14px;
    margin: 8px auto 0;
    max-width: 244px;
    text-align: center;
    line-height: 1.2;
  }
}

.custom-button {
  text-transform: unset !important;
  letter-spacing: 0.02px !important;
  color: #fff;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  width: 216px;
  height: 43px !important;
}

@media screen and (max-width: 768px) {
  .card-content {
    p {
      display: none;
    }
  }
}
</style>
